module.exports = __webpack_public_path__ + "img/business-light.ee8b5d83.png";